<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['migrate']==1">
    <div class="row">
      <div class="col-12">
        <div class="card shadow-lg">
          <div class="card-body">
            <div class="my-2">
              <div class="row">
                <b-form-group class="col-md-3" label="Term">
                  <v-select :options="schoolterms" placeholder="Select Term" v-model="schoolterm" label="name"></v-select>
                </b-form-group>
                <b-form-group class="col-md-2" label="Year">
                  <v-select :options="years" placeholder="Select Year" v-model="year"></v-select>
                </b-form-group>
                <b-form-group class="col-md-3" label="Class">
                  <v-select :options="schoolclasses" @input="FilterStream" placeholder="Select Class" v-model="schoolclass" label="name"></v-select>
                </b-form-group>
                <b-form-group class="col-md-3" label="Stream">
                  <v-select :options="schoolstreams" placeholder="Select Stream" v-model="schoolstream" label="name"></v-select>
                </b-form-group>
                <div class="col-md-1 mt-md-4 mt-2 p-lg-0">
                <b-button variant="primary" @click="FilterData()"><i class="mdi mdi-account-search"></i> Filter</b-button>
              </div>
            </div>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Selected Yet</strong></div></template>
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(student_photo)="data">
                <img :src="getFiles(data.item.student.student_photo)" height="50"/>
              </template>
              <template #cell(student_id)="data">
                <b class="text-danger">{{ data.item.student.student_id }}</b> <br>
              </template>
              <template #cell(student)="data">
                {{ data.item.student.first_name }} {{ data.item.student.last_name }}
              </template>
              <template #cell(gender)="data">
                {{ data.item.student.gender }}
              </template>
              <template #cell(actions)="data">
                <select class="form-control" v-model="data.item.status" @change="changeStatus(data.item.student.student_id,data.item.status)">
                    <option value="1">Promoted</option><option value="2">Repeated</option><option value="0">Left</option>
                </select>
              </template>
              </b-table>
            </div>
            
            <div class="row">
            </div>
            <span v-if="this.studentpromotes.length>0">
            <div class="row">
                <b-form-group class="col-3" label="Class To">
                    <v-select :options="schoolclasses" @input="FilterStream" placeholder="Select Class" v-model="promoteclass" label="name"></v-select>
                </b-form-group>
                <b-form-group class="col-3" label="Term">
                    <v-select :options="schoolterms" placeholder="Select Term" v-model="promoteterm" label="name"></v-select>
                </b-form-group>
                <b-form-group class="col-3" label="Stream">
                    <v-select :options="schoolstreams" placeholder="Select Stream" v-model="promotestream" label="name"></v-select>
                </b-form-group>
                <div class="col-3 mt-4"><b-button :disabled="loader" class="btn" @click="PromoteStudents" variant="success">Promote <b-spinner v-if="loader" small class="mr-1" label="Small Spinner"/> <i v-else class="mdi mdi-arrow-right"></i></b-button></div>
                <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                    </ul>
                </div>
                </div>    
            </div>    
            </span>
          </div>
        </div>
      </div>
    </div>
    </div>      
  <div v-else>
    <div class="row justify-content-center">
      <div class="col-md-8 col-xl-6">
        <div>
          <center><span class="text-primary h4">You have no permission to view the Dashboard.</span></center>
          <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
        </div>
      </div>
    </div>
  </div> 
  </Layout>
</template>

<script>
import axios from "axios";
// import Multiselect from "vue-multiselect";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { schoolclassComputed, schoolclassMethods, schooltermComputed, schooltermMethods, studentpromoteComputed, studentpromoteMethods } from "@/state/helpers";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "Promote Students",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout,PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Promote Students",
      items: [ {text: "Dashboard",to: "/",}, {text: "Promote Students",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'student_photo', label: 'Photo', visible: true },
          { key: 'student_id', label: 'Student ID', visible: true },
          { key: 'student', label: 'Name', visible: true },
          { key: 'gender', label: 'Gender', visible: true },
          { key: 'actions', label: 'Actions', visible: true },
        ],
      id:'',
      name:'',
      schoolterm:'', schoolclass:'', schoolstream:'', schoolstreams:[],
      year:new Date().getFullYear(),
      promoteterm:'',
      promoteclass:'',
      promotestream:'',
      loader:false,
    };
  },
  computed: {
    ...studentpromoteComputed,
    ...schoolclassComputed,
    ...schooltermComputed,
    List() { return this.studentpromotes.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.studentpromotes.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.studentpromotes.length>0) { a=false;} else { a=true;} return a },
    Cart() { return this.studentpromotes.map((d) => ({id:d.id,student:d.student.student_id,status:d.status }))},
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {  yearArray.push(year);  }
      return yearArray;
    },
  },
  mounted() {
    this.fetchSchoolClasses();
    this.fetchSchoolTerms();
    this.TotalRows = this.studentpromotes.length;
    this.isBusy=false;
    this.schoolterm = this.schoolterms.find(option => option.active == 1);
  },
  methods: {
    ...studentpromoteMethods,
      ...schoolclassMethods,
      ...schooltermMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async FilterStream(){
        let url = `/findschoolstream/${this.schoolclass.id}`;
        await axios.get(url).then((response) => {
            this.schoolstreams = response.data.streams;
        });
    },
    getFiles(name){
      let url = axios.defaults.baseURL;
      let imagelink = (url).slice(0,-3)+"students/"+name;
      return imagelink;
    },
    FilterData() {
      this.addStudents({schoolterm:this.schoolterm.id,year:this.year,schoolclass:this.schoolclass.id,schoolstream:this.schoolstream.id});
    },
    FetchData() {
      this.fetchStudents({schoolterm:this.schoolterm.id,year:this.year,schoolclass:this.schoolclass.id,schoolstream:this.schoolstream.id});
    },
    async changeStatus(student,status) { 
        let formData = new FormData();
        formData.append("student", student);
        formData.append("status", status);
        let url = "/updatestudentpromotes";
        await axios.post(url, formData).then((response) => { 
        if (response.status == 200) {
            this.FetchData()
        }  });
    },
    async PromoteStudents(){
        this.loader=true;
        let obj = {
            students:this.Cart,
            class:this.promoteclass.id,
            term:this.promoteterm.id,
            stream:this.promotestream.id,
        }
        let url = "/migratestudent";
        await axios.post(url, obj).then((response) => {
        if (response.status == 200) {
            this.FetchData()
            this.loader=false;
            this.$swal({ title:'Success', text:response.data.message, icon:'success'});
           }
         });
        }
  },
};
</script>